import React from 'react'
import { IconButton } from '@mui/material'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'

const FloatingHelpButton = ({ startHelp }) => {
  return (
    <IconButton
      onClick={startHelp}
      sx={{
        zIndex: 1400,
        position: 'fixed',
        bottom: 60,
        right: 20,
        bgcolor: 'primary.main',
        color: 'white',
        boxShadow: 3,
        '&:hover': {
          bgcolor: 'primary.dark',
        },
      }}
    >
      <HelpOutlineIcon />
    </IconButton>
  )
}

export default FloatingHelpButton
